module.exports = __webpack_public_path__ + "media/images/gallery/constellations/pn_layer_off-8423c5713113a5a72dd23fd7697310b9.png";